<template>
  <div class="lotteryProxy">
    <div
      v-if="Number(lotteryCount)!==2"
      class="lotteryProxy-module"
    >
      <div class="lotteryProxy-module__title">
        <div class="left-icon"></div>
        <div class="middle-title">
          必得数字人民币好礼
        </div>
        <div class="right-icon"></div>
      </div>
      <lottery-swiper class="lotteryProxy-module__swiper"></lottery-swiper>
    </div>
    <div
      v-if="btnText"
      ref="applyIndexButton"
      class="lotteryProxy-indexBtn"
      @click="lotteryHandle"
    >{{ btnText }}</div>
    <div
      v-if="hctUserRewardInfoBOS && hctUserRewardInfoBOS.length>0"
      class="lotteryProxy-module"
    >
      <div class="lotteryProxy-module__title">
        <div class="left-icon"></div>
        <div class="middle-title myLottery-title">
          我的好彩头
        </div>
        <div class="right-icon"></div>
      </div>
      <div
        v-for="(hctUserRewardInfo, index) in hctUserRewardInfoBOS"
        :key="index"
        class="lotteryProxy-module__container"
      >
        <my-lottery
          :hctUserRewardInfo="hctUserRewardInfo"
          :appPortrait="appPortrait"
          :portraitStatus="portraitStatus"
          :lotteryCount="lotteryCount"
          :cityCode="cityCode"
          @refresh="refresh"
          @toDcepWear="toDcepWear($event)"
        ></my-lottery>
      </div>
    </div>
    <div class="lotteryProxy-banner">
      <pgy-ad-sdk
        :options="pgyOptions"
        :pos-id="12526"
        :env="env"
        :utm_source="utm_source"
      ></pgy-ad-sdk>
    </div>
    <div class="lotteryProxy-partner"></div>
    <div class="lotteryProxy-search">
      <div class="lotteryProxy-search__icon"></div>
      上美团App，搜索“团圆好彩头”</div>
    <div
      v-if="btnText && isShowFixedButton"
      class="lotteryProxy-footer"
    >
      <div class="lotteryProxy-footer__bottom">
        <div
          class="lotteryProxy-footer__btn"
          @click="lotteryHandle"
        >
          {{ btnText }}
        </div>
      </div>
    </div>
    <basic-modal
      :visible.sync="showModal"
      :modalMessage="modalMessage"
      @onConfirm="toDcepWear"
    ></basic-modal>
    <lottery-modal
      :visible.sync="isShowLotteryModal"
      :hctUserRewardInfoBOS="currentHctUserRewardInfoBOS"
      :appPortrait="appPortrait"
      :portraitStatus="portraitStatus"
      :lotteryCount="currentLotteryCount"
      :cityId="cityCode"
      @onShareLottery="onShareLottery"
    ></lottery-modal>
    <share-modal
      :visible.sync="isShowShareModal"
      :hctUserRewardInfoBOS="hctUserRewardInfoBOS"
      :appPortrait="appPortrait"
      :cityId="cityCode"
      :portraitStatus="portraitStatus"
      :lotteryCount="lotteryCount"
    ></share-modal>
    <pgy-ad-sdk
      :options="pgyOptions"
      :pos-id="63337"
      :env="env"
      :utm_source="utm_source"
      @update:visible="handleBulletinVisibleChange($event)"
    ></pgy-ad-sdk>
  </div>
</template>

<script>
import Vue from 'vue';
import { Toast } from 'vant';
import { dcepAppConfig, lotteryActivityId } from '@/common/config';
import { monitor } from '@/common/monitor';
import { env } from '@/common/env';
import { api } from '@/common/api';
import { lx } from '@/analytic/index';
import { lxConfig } from '@/analytic/profilePhoto';
import { PgyAdSdk } from '@fdfe/marketing-sdk';
import { fixScrollDeep, resetDocumentScroll } from '@/common/utils';
import LotterySwiper from '../components/LotterySwiper.vue';
import MyLottery from '../components/MyLottery.vue';
import BasicModal from '../components/BasicModal.vue';
import LotteryModal from '../components/LotteryModal/index.vue';
import ShareModal from '../components/ShareModal/index.vue';

Vue.use(Toast);

export default {
  components: {
    LotterySwiper,
    MyLottery,
    BasicModal,
    LotteryModal,
    ShareModal,
    PgyAdSdk
  },
  props: {
    hctUserRewardInfoBOS: {
      type: Array,
      default: () => []
    },
    lotteryCount: {
      type: String,
      default: ''
    },
    shareStatus: {
      type: Boolean,
      default: false
    },
    portraitStatus: {
      type: Boolean,
      default: false
    },
    appPortrait: {
      type: String,
      default: ''
    },
    cityCode: {
      type: String,
      default: ''
    },
    bankIdStr: {
      type: String,
      default: ''
    },
    lotteryStatus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modalMessage: {
        title: '请先生成数字人民币专属头像',
        message: '在数字人民币App生成专属头像后，就可以再抽一次好彩头啦～',
        btnText: '去生成头像'
      },
      showModal: false,
      isShowFixedButton: false,
      isShowShareModal: false,
      currentHctUserRewardInfoBOS: null,
      currentLotteryCount: '0',
      isShowLotteryModal: false,
      env: env.pgyEnv,
      pgyOptions: {
        appkey: '',
        reportData: {
          from: '',
          config_id: ''
        }
      },
      utm_source: env.from || '-999',
    };
  },
  computed: {
    btnText() {
      if (this.lotteryStatus) {
        // 抽奖已结束
        return '';
      }
      if (Number(this.lotteryCount) === 0) {
        // 未抽奖
        return '抽取好彩头';
      }
      if (Number(this.lotteryCount) === 1) {
        // 抽奖一次
        if (this.shareStatus) {
          // 已分享
          return '再抽一次好彩头';
        } else {
          return '分享彩头 再抽一次';
        }
      }
      return '';
    }
  },
  mounted() {
    lx.pv(lxConfig.index_pv, {
      from: env.from || -999,
      activity_id: env.actGroupName || lotteryActivityId,
      bank_id: this.bankIdStr || -999,
      city_id: this.cityCode || -999,
      page_status: this.lotteryCount || -999,
      user_status: this.portraitStatus ? 1 : 0
    });
    window.addEventListener('scroll', this.handleapplyButtonMove, true);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleapplyButtonMove, true);
  },
  methods: {
    handleapplyButtonMove() {
      const btn = this.$refs.applyIndexButton;
      if (!btn) {
        return;
      }
      const iNotInViewport = this.isElementNotInViewport(btn);
      if (iNotInViewport) {
        this.isShowFixedButton = true;
      } else {
        this.isShowFixedButton = false;
      }
    },
    isElementNotInViewport(el) {
      const rect = el.getBoundingClientRect();
      const titleBar = document.getElementById('titleBar');
      const titleBarRect = titleBar && titleBar.getBoundingClientRect();
      const barHeight = (titleBarRect && titleBarRect.height) || 0;
      return (
        rect.top >= (window.innerHeight || document.documentElement.clientHeight)
        || (rect.bottom - barHeight) <= 0
      );
    },
    lotteryHandle() {
      this.lxMc(lxConfig.lottery_index_btn_mc);
      if (Number(this.lotteryCount) === 0) {
        this.drawLottery();
      } else if (Number(this.lotteryCount) === 1) {
        if (this.shareStatus) {
          // 已分享
          if (this.portraitStatus) {
            // 已设置头像
            this.drawLottery();
          } else {
            // 未设置头像
            this.showModal = true;
            lx.mv(lxConfig.set_avator_modal_mv, {
              from: env.from || -999,
              activity_id: env.actGroupName || lotteryActivityId,
              bank_id: this.bankIdStr || -999,
              city_id: this.cityCode || -999,
              page_status: this.lotteryCount || -999,
              user_status: this.portraitStatus ? 1 : 0
            }, {
              cid: lxConfig.index_pv
            });
          }
        } else {
          // 未分享
          this.isShowShareModal = true;
        }
      }
    },
    drawLottery() {
      api.drawLottery().then((res) => {
        if (!res) {
          monitor.captureMessage({
            name: '【好彩头】-drawLottery',
            msg: '接口返回为空'
          },
          {
            level: 'error'
          });
          throw Error('系统异常，请稍后再试');
        }
        if (res.status !== 'SUCCESS') {
          const failMessage = res.failMessage;
          Toast(failMessage.title || failMessage.message || '系统异常，请稍后再试');
          return;
        }
        this.$emit('refresh');
        this.currentHctUserRewardInfoBOS = res.hctUserRewardInfoBOS || [];
        this.currentLotteryCount = res.lotteryCount;
        this.isShowLotteryModal = true;
      }).catch((err) => {
        monitor.captureMessage({
          name: '【好彩头】-drawLottery',
          msg: JSON.stringify(err)
        },
        {
          level: 'error'
        });
      });
    },
    async toDcepWear(decorationId) {
      try {
        if (!decorationId) {
          lx.addTag({
            c_fsp_dcep_j4pmca31: {
              bid: lxConfig.set_avatar_btn_mc
            }
          });
          this.lxMc(lxConfig.set_avatar_btn_mc);
          const rewardInfoList = (this.hctUserRewardInfoBOS && this.hctUserRewardInfoBOS[0] && this.hctUserRewardInfoBOS[0].singleRewardInfos) || [];
          const singleRewardInfo = rewardInfoList.filter((item) => item.rewardType === 'ACCESSORY') || [];
          const extObj = JSON.parse(singleRewardInfo[0].ext) || {};
          decorationId = extObj.decorationId;
        }
        // returnUrl
        const originUrl = window.location.href;
        const paramsObj = env.businessParams || {};
        const paramsList = Object.keys(paramsObj);
        let paramsUrl = '';
        // 添加业务参数
        paramsList.forEach((item) => {
          if (paramsObj[item]) {
            paramsUrl = `${paramsUrl}&${item}=${paramsObj[item]}`;
          }
        });
        const urlList = originUrl.split('#') || [];
        const path = urlList[0].includes('?') ? `${urlList[0]}&${paramsUrl}` : `${urlList[0]}?${paramsUrl}`;
        const callbackUrl = urlList[1] ? `${path}#${urlList[1]}` : path;
        const mtScheme = 'imeituan://web';
        const encodeCallbackUrl = encodeURIComponent(callbackUrl);
        const returnUrl = `${mtScheme}?url=${encodeCallbackUrl}&needSpliceParams=true`;
        const params = {
          decorationId,
          returnUrl,
          phoneNo: this.hctUserRewardInfoBOS && this.hctUserRewardInfoBOS[0].phoneNo
        };
        const res = await this.querySignInfo(params);
        if (!res) {
          // 接口异常，降级
          this.jumpToDcepApp();
          return;
        }
        const {
          sign,
          signInfo,
          bizType,
          appId,
          extraInfo,
          instNo
        } = res;
        const url = `${dcepAppConfig.bindWalletScheme}?appId=${encodeURIComponent(
          appId
        )}&extraInfo=${encodeURIComponent(extraInfo)}&biz=${encodeURIComponent(
          bizType
        )}&instNo=${encodeURIComponent(instNo)}&signInfo=${encodeURIComponent(
          signInfo
        )}&sign=${encodeURIComponent(sign)}`;
        this.$bridge.openPage(url, (err) => {
          monitor.captureMessage(
            {
              name: '【佩戴头像】打开数币App失败',
              msg: JSON.stringify(err)
            },
            {
              level: 'info'
            }
          );
          // 打开数币App失败，降级跳转到下载页面
          this.downloadApp();
          return;
        });
      } catch (err) {
        // 异常降级
        this.jumpToDcepApp();
        monitor.captureMessage(
          {
            name: '去佩戴头像失败',
            msg: JSON.stringify(err)
          },
          {
            level: 'error'
          }
        );
      }
    },
    async querySignInfo(params) {
      try {
        const res = await api.querySignInfo(params);
        return res;
      } catch (err) {
        monitor.captureMessage(
          {
            name: '【好彩头】querySignInfo',
            msg: JSON.stringify(err)
          },
          {
            level: 'error'
          }
        );
        return '';
      }
    },
    jumpToDcepApp() {
      const url = dcepAppConfig.appId.commonLink;
      this.$bridge.openPage(url, (err) => {
        // 打开数币App失败，降级跳转到下载页面
        this.downloadApp();
        monitor.captureMessage(
          {
            name: '打开数币App失败',
            msg: JSON.stringify(err)
          },
          {
            level: 'info'
          }
        );
      });
    },
    downloadApp() {
      const url = env.isIOS
        ? dcepAppConfig.downloadUrl.iosUrl
        : dcepAppConfig.downloadUrl.androidUrl;
      const errorMsg = env.isIOS ? 'App Store' : '应用商店';
      this.$bridge.openPage(url, (err) => {
        Toast(`打开/下载数币App失败，可自行到${errorMsg}下载`);
        monitor.captureMessage(
          {
            name: '下载数币App失败',
            msg: JSON.stringify(err)
          },
          {
            level: 'error'
          }
        );
      });
    },
    onShareLottery() {
      this.isShowShareModal = true;
    },
    lxMc(bid) {
      lx.mc(bid, {
        from: env.from || -999,
        activity_id: env.actGroupName || lotteryActivityId,
        bank_id: this.bankIdStr || -999,
        city_id: this.cityCode || -999,
        page_status: this.lotteryCount || -999,
        user_status: this.portraitStatus ? 1 : 0
      }, {
        cid: lxConfig.index_pv
      });
    },
    refresh() {
      this.$emit('refresh');
    },
    handleBulletinVisibleChange(isShow) {
      if (isShow) {
        fixScrollDeep();
      } else {
        resetDocumentScroll();
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../styles/fn.less";
@import "../../../styles/base.less";
.lotteryProxy {
  margin: 5.9rem 0.3rem 0.61rem 0.3rem;
  position: relative;
  .lotteryProxy-module {
    .lotteryProxy-module__title {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: auto;
    }
    .left-icon {
      width: 0.33rem;
      height: 0.24rem;
      .bg-image-auto('https://p1.meituan.net/wxapp/3020bc94e4a2a2b1ef812db2655a05bc503.png');
      -moz-transform:scaleX(-1);
      -webkit-transform:scaleX(-1);
      -o-transform:scaleX(-1);
      transform:scaleX(-1);
    }
    .right-icon {
      width: 0.33rem;
      height: 0.24rem;
      .bg-image-auto('https://p1.meituan.net/wxapp/3020bc94e4a2a2b1ef812db2655a05bc503.png');
    }
    .middle-title {
      font-weight: 400;
      font-family: 'MF-YuanHeiNoncommercial-Regular';
      font-size: 0.4rem;
      color: #FFFDE5;
      background-image: linear-gradient(to bottom,#FFFFFF, #FFF9D8);
      background-clip: text;
      -webkit-text-fill-color: transparent;
      letter-spacing: 2px;
      text-align: center;
      margin: auto 0.24rem;
      line-height: 1;
    }
    .myLottery-title {
      margin-bottom: 0.08rem;
    }
    .lotteryProxy-module__swiper {
      margin: 0.35rem -0.3rem 0.42rem -0.3rem;
    }
    .lotteryProxy-module__container {
      margin-top: 0.82rem;
    }
  }
  .lotteryProxy-banner {
    width: 100%;
    margin: 0.27rem auto 0.5rem;
  }
  .lotteryProxy-partner {
    .bg-image-auto('https://p0.meituan.net/wxapp/cf20cef43164d445eb2d339ea511204133568.png');
    width: 100%;
    height: 3.06rem;
    margin: 0.3rem auto 0.65rem;
  }
  .lotteryProxy-search {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC-Regular;
    font-size: 0.247rem;
    color: #8D1827;
    letter-spacing: 0.02px;
    font-weight: 400;
    padding-bottom: 0.5rem;
    .lotteryProxy-search__icon {
      width: 0.28rem;
      height: 0.28rem;
      margin-right: 0.1rem;
      .bg-image-auto('https://p0.meituan.net/wxapp/fd3ac723496b2baed251688d6685e237804.png');
    }
  }
  .lotteryProxy-indexBtn {
    margin: auto auto 0.54rem;
    text-align: center;
    width: 5.82rem;
    height: 1.06rem;
    line-height: 1.06rem;
    font-family: PingFangSC-Semibold;
    font-size: 0.34rem;
    color: #5D1B06;
    text-align: center;
    font-weight: 600;
    .bg-image-auto('https://p0.meituan.net/wxapp/7bc928cfccd2cfd4546a595ccb20eccc19923.png');
  }
  .lotteryProxy-footer {
    width: 100%;
    height: 1.8rem;
    margin-top: -0.61rem; // 避免没有按钮时底部留白
    position: relative;
    z-index: 999;
    .lotteryProxy-footer__bottom {
      position: fixed;
      bottom: 0;
      height: 1.8rem;
      left: 0;
      right: 0;
      margin: auto;
      background-image: linear-gradient(180deg, rgba(238,56,79,0.00) 0%, #EE384F 44%);
    }
    .lotteryProxy-footer__btn {
      margin: auto;
      text-align: center;
      width: 5.82rem;
      height: 1.06rem;
      line-height: 1.06rem;
      font-family: PingFangSC-Semibold;
      font-size: 0.34rem;
      color: #5D1B06;
      text-align: center;
      font-weight: 600;
      .bg-image-auto('https://p0.meituan.net/wxapp/7bc928cfccd2cfd4546a595ccb20eccc19923.png');
    }
  }
}
</style>
